import { z } from "zod";
import { zCodeListSchema, zEmailSchema, zString } from "./commonSchemaObjects";
import { passwordValidation } from "../../constants/regex";
 
export const esignSchema = z.object({
  sign_reason: zCodeListSchema,
  email: zEmailSchema,
  password: zString.zRequired
    .min(8, "Password should have minimum 8 characters")
    .regex(passwordValidation, "Password is not in expected format"),
});